module.exports = __webpack_public_path__ + "img/example-cafeteria-menu-fr.12a9b0ea.jpg";